import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import IconButton from '@mui/material/IconButton'
import CustomBackdrop from 'common/components/CustomBackdrop'
import i18n from 'lang/idiomas'
import { SnackbarProvider, closeSnackbar, enqueueSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import { fetchSSO } from '../libs/fetchSSO'

const SingleSignOn = ({ object: sso }) => {
  const [openBackdrop, setOpenBackdrop] = useState(true)

  const handleClick = async () => {
    try {
      setOpenBackdrop(true)
      const response = await fetchSSO(sso)
      setOpenBackdrop(false)
      window.open(response.url, '_self')
    } catch (error) {
      setOpenBackdrop(false)
      enqueueSnackbar(`No se ha podido conseguir el acceso`)
    }
  }

  useEffect(() => {
    handleClick()
  }, [])

  return (
    <>
      <SnackbarProvider
        maxSnack={1}
        autoHideDuration={6000}
        action={(snackbarId) => (
          <IconButton onClick={() => closeSnackbar(snackbarId)} aria-label="cerrar alerta">
            <CloseRoundedIcon />
          </IconButton>
        )}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        variant={'error'}
      />
      <CustomBackdrop
        open={openBackdrop}
        text={i18n.t('abriendoEnlace', { defaultValue: 'Abriendo enlace' })}
      />
    </>
  )
}
export default SingleSignOn
